import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./field.script";
export function RuiField({
  children,
  rules,
  defaultValue,
  defaultValueData,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-field", {
    ...props,
    "prop:rules": rules,
    "prop:defaultValue": defaultValue,
    data: {
      defaultValue: defaultValueData ?? (defaultValue !== void 0 ? JSON.stringify(defaultValue) : void 0)
    },
    children: /* @__PURE__ */jsx("div", {
      class: "rui-field",
      children
    })
  });
}